import React from 'react';

const HighlightContext = React.createContext(null);

export default HighlightContext;
